import DetailsState from "./detailsState";
import {detailsActions, DetailsStateActions} from "./detailsState.types";
import {
  AcceptConditions,
  SetProblemDescription,
  SetCustomerPhone,
  SetCustomerName,
  SetCustomerEmail,
  SetSpecialNeeds,
  Next,
  SetKlippeCard,
  SetPromoCode,
  SetBookingReasons,
  SetParkingText,
  SetCompanyName,
  SetCompanyAdminName,
  SetGiftCard,
} from "./actions";
export default DetailsState;
export {
  detailsActions,
  Next,
  AcceptConditions,
  SetProblemDescription,
  SetCustomerPhone,
  SetCustomerName,
  SetCustomerEmail,
  SetSpecialNeeds,
  SetKlippeCard,
  SetPromoCode,
  SetBookingReasons,
  SetParkingText,
  SetCompanyName,
  SetCompanyAdminName,
  SetGiftCard,
};
export type {DetailsStateActions};
